<template>
  <a-modal
    :visible="visible"
    :width="500"
    title="新增企业"
    :footer="null"
    @cancel="$emit('cancel')"
  >
    <a-spin :spinning="spinning">
      <a-form :form="form" v-bind="formItemLayout" @submit="handlePost">
        <a-form-item label="退保申请书">
          <div class="overflow-hidden">
            <a-input v-show="false" v-decorator="['img_id']"></a-input>
            <Upload :src="info.img" @upload="Upload"></Upload>
          </div>
        </a-form-item>
        <a-form-item label="模板下载">
          <a class="overflow-hidden text-red-500" @click="downloadExcel"> 退保申请书 </a>
        </a-form-item>
        <a-form-item label="意见">
          <a-textarea v-decorator="['text']" autoSize></a-textarea>
        </a-form-item>

        <a-form-item :wrapperCol="{ span: 14, offset: 6 }">
          <a-button class="mr-6" type="primary" size="default" html-type="submit"> 提交</a-button>
          <a-button size="default" @click="$emit('cancel')">取消</a-button></a-form-item
        >
      </a-form>
    </a-spin>
  </a-modal>
</template>
<script>
  import { contract_cancel } from '@/api/contract';
  import Upload from '@/components/Upload/index';
  export default {
    components: {
      Upload,
    },
    props: {
      visible: Boolean,
      record: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        formItemLayout: {
          labelCol: { span: 6 },
          wrapperCol: { span: 14 },
        },
        form: this.$form.createForm(this, { name: 'refund' }),
        info: {},
        spinning: false,
        certOwner: '',
        check_owner: true,
      };
    },
    watch: {
      visible(a) {
        if (a) {
          setTimeout(() => this.form.resetFields(), 1);
        }
      },
    },
    methods: {
      async Upload(res) {
        try {
          setTimeout(() => this.form.setFieldsValue({ img_id: res.id }), 1);
          this.$set(this.info, 'img', res.pathname);
        } catch (error) {
          this.$message.error(error);
        }
      },
      downloadExcel() {
        window.open(
          'https://zjsxrz.oss-cn-hangzhou.aliyuncs.com/static/%E5%B0%9A%E4%BF%A1%E9%80%80%E4%BF%9D%E7%94%B3%E8%AF%B7%E4%B9%A6.docx',
          '信吉退保申请书.docx',
          '__blank',
        );
      },
      async handlePost(e) {
        e.preventDefault();
        this.form.validateFieldsAndScroll(async (err, values) => {
          if (!err) {
            try {
              this.spinning = true;
              let data = Object.assign({}, this.record, this.info, values);
              await contract_cancel(data);
              this.$emit('ok', data);
            } catch (error) {
              this.$error({ title: '错误提示', content: error });
            } finally {
              this.$emit('cancel');
              this.spinning = false;
            }
          } else {
            console.log(values);
          }
        });
      },
    },
  };
</script>
<style scoped lang="less">
  :deep(.ant-row) {
    position: static;
  }
</style>
